module.exports = __webpack_public_path__ + "static/media/home-gewicht.41487e3d.jpg";